import React from 'react';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { fetchAdvSeoDetails, getAdditionalPage } from '../../../services';
import AiBlogPage from '@/containers/BlogPage/AiBlogPage';
import Layout from '@/components/Layout';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { SEO_TYPE } from 'src/utils/constants/common';
import { handleCategoryCollectionRedirect } from 'src/utils/productUtils';
import { set404Response } from 'src/utils/404Redirect';
import Error404 from 'src/containers/404Page';

const AdditionalPageContainer = (props) => {
  const blogSeoResponse = props?.blogSeoData;
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  if(props?.notFound) {
    return <Error404 />;
  }

  return (
    <Layout
      store={storeInfo}
      title={
        blogSeoResponse?.title?.value ||
        `${props?._addPage?.page_name} - ${storeInfo?.store_info?.name}`
      }
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        blogSeoResponse?.description ||
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={blogSeoResponse?.og_title?.value || null}
      OGDescription={blogSeoResponse?.og_description || null}
      OGImage={props?._addPage?.featured_image || storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={props?._addPage?.redirect_url}
      {...props}
    >
      <AiBlogPage {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx))
    return {
      props: {},
    };
  const { slug, preview } = ctx.query;
  let propData = {
    catalogCategories: [],
    _addPage: null,
    blogSeoData: null,
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    advancedSeoReqConfigs: {
      type: 'additional_page',
      typeId: propData?._addPage?.page_id,
    },
  });

  const _addpageResponse = await getAdditionalPage(
    slug,
    propType.ssrStore.storeReducer.store.store_id,
    Boolean(Number(preview)),
    undefined,
    2,
  );

  if (_addpageResponse.data && _addpageResponse.data.status) {
    propData._addPage = JSON.parse(JSON.stringify(_addpageResponse.data.page)) || null;
    const blogSeoResponse = await fetchAdvSeoDetails({
      type: SEO_TYPE.BLOG,
      typeId: propData?._addPage?.page_id,
      storeId: propType?.ssrStore?.storeReducer?.store?.store_id,
    });

    if (blogSeoResponse.data && blogSeoResponse.data?.status) {
      propData.blogSeoData = JSON.parse(blogSeoResponse.data?.data);
    }
    if ( _addpageResponse.data?.page?.is_redirected) {
      const redirectionLink = _addpageResponse?.data?.page?.redirect_url;
      return handleCategoryCollectionRedirect({ ctx, redirectionLink });
    }
  } else {
    return set404Response(ctx, propType);
  }

  propData = { ...propData, ...propType };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}
export default AdditionalPageContainer;
